import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { ParagraphBlock } from '../types';
import { RichSegments } from './RichSegments';
import styles from './Paragraph.module.css';
interface ParagraphProps {
  block: ParagraphBlock;
  blockId: string;
}
export function Paragraph(t0) {
  const $ = _c(12);
  const {
    block,
    blockId
  } = t0;
  const t1 = block.variant === "lead" ? styles.lead : null;
  const t2 = block.variant === "leadBody" ? styles.leadBody : null;
  const t3 = block.variant === "leadAlert" ? styles.leadAlert : null;
  const t4 = block.variant === "body24" ? styles.body24 : null;
  let t5;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = [styles.paragraph, t1, t2, t3, t4].filter(Boolean);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const className = t5.join(" ");
  let t6;
  if ($[5] !== block.segments) {
    t6 = <RichSegments segments={block.segments} />;
    $[5] = block.segments;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== block.variant || $[8] !== blockId || $[9] !== className || $[10] !== t6) {
    t7 = <p className={className} data-cms-block-id={blockId} data-cms-field="paragraph" data-cms-variant={block.variant}>{t6}</p>;
    $[7] = block.variant;
    $[8] = blockId;
    $[9] = className;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}